import React, {
  createContext,
  ReactElement,
  ReactNode,
  useContext,
} from "react";
import {
  ApolloClient,
  DocumentNode,
  InMemoryCache,
  OperationVariables,
  QueryHookOptions,
  QueryResult,
  useQuery,
} from "@apollo/client";

export const CbCityGraphQlContext = createContext<
  ApolloClient<unknown> | undefined
>(undefined);

interface CbCityGraphQlContextProviderProps {
  readonly children: ReactNode;
}

export function CbCityGraphQlContextProvider({
  children,
}: CbCityGraphQlContextProviderProps): ReactElement {
  const apiClient = new ApolloClient({
    uri: "https://cbc-backend.azurewebsites.net/",
    cache: new InMemoryCache(),
  });

  return (
    <CbCityGraphQlContext.Provider value={apiClient}>
      {children}
    </CbCityGraphQlContext.Provider>
  );
}

export const useCbCityGraphqlClient = (): ApolloClient<unknown> => {
  const client = useContext(CbCityGraphQlContext);
  if (!client) {
    throw new Error("No graphql API context");
  }
  return client;
};

export function useApiQuery<TData = any, TVariables = OperationVariables>(
  query: DocumentNode,
  options?: Omit<QueryHookOptions<TData, TVariables>, "client">
): QueryResult<TData, TVariables> {
  const client = useCbCityGraphqlClient();
  return useQuery<TData, TVariables>(query, {
    ...options,
    notifyOnNetworkStatusChange: true,
    client,
  });
}
